<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="width: 90%; height: 100%; margin: auto; padding-top: 2vh">


    <div (click)="toIndicators()" class="row deviceSection">
      <div class="deviceHeader">
        <h1 class="centerVert textXXM">{{this.localiser.get("indicators.sensors")}}</h1>
      </div>
    </div>

    <div class="bodyChart">

      <!-- PRESENCE -->
      <div style="height: 100%;">

        <div class="filterRow">
          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f; margin: auto">{{this.localiser.get('devices.searcher')}}</h3>
            <div class="searcherDiv">
              <div class="col-2" style="text-align: right">
                <span class="material-icons-outlined textXM centerVert" style="color: #18264f">
                  search
                </span>
              </div>
              <div class="col" style="text-align: left;">
                <input [(ngModel)]="searcherLuminarias"  (input)="searcherLuminariasFunc()" type="text"
                       class="centerVert textS searcherInput" placeholder=" " maxlength="50">
              </div>
            </div>
          </div>

          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">{{this.localiser.get("devices.floorplan")}}</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectPlano($event.value)" [(ngModel)]="planoSelected">
              <mat-option class="textS" [value]="-1">{{this.localiser.get("devices.all")}}</mat-option>
              <mat-option class="textS" *ngFor="let plano of planos"
                          [value]="plano">{{plano.nombre}}</mat-option>
            </mat-select>
          </div>
          <div class="col-4" style="margin: auto">
            <h3 class="textS+" style="color: #18264f">{{this.localiser.get("devices.zone")}}</h3>
            <mat-select class="upperButton textS" (selectionChange)="selectZona($event.value)" [(ngModel)]="zonaSelected">
              <mat-option class="textS" [value]="-1">{{this.localiser.get("devices.all")}}</mat-option>
              <mat-option class="textS" *ngFor="let zona of showZonas" [value]="zona">{{zona.nombre}}</mat-option>
            </mat-select>
          </div>
        </div>

        <div class="row" style="height: 100%; margin-top: 2%">
          <div class="col-4">
            <div class="col luminariasList">
              <h4 class="textS+" style="text-decoration: underline">
                {{this.localiser.get("indicators.sensorList")}}
              </h4>
              <div *ngFor="let sensor of this.sensores; index as i" class="luminariaBox">
                <div (click)="changeSelectSensor(sensor)" class="luminariaRow"
                     [ngClass]="{'selectedRow': checkSelectedSensor(sensor)}">
                  <h6 class="textS" style="text-decoration: underline; margin: 1% auto"> {{sensor.nombre}} </h6>
                  <h6 class="textS" style="margin: 1% auto"> {{sensor.idLuminaria}} </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="row" style="height: 65%">
              <canvas id="sensorsChart"></canvas>
              <div *ngIf="loading" style="width: 100%; height: 100%; position: absolute">
                <mat-progress-spinner style="margin: auto; top: 30%" class="marginAuto" color="primary" mode="indeterminate" diameter="100">
                </mat-progress-spinner>
              </div>
            </div>
            <div class="row textS" style="height: 15%; margin: auto">
              <div class="col-9" style="margin: auto; text-align: center;">
                <button class="leftButton" (click)="changeSensorsFilterTime(1)"
                        [ngClass]="{'selectedButton': this.sensorsFilterTime == 1}">{{this.localiser.get('indicators.today')}}</button>
                <button class="centerButton" (click)="changeSensorsFilterTime(2)"
                        [ngClass]="{'selectedButton': this.sensorsFilterTime == 2}">{{this.localiser.get('indicators.yesterday')}}</button>
                <button class="centerButton" (click)="changeSensorsFilterTime(3)"
                        [ngClass]="{'selectedButton': this.sensorsFilterTime == 3}">{{this.localiser.get('indicators.week')}}</button>
                <button class="centerButton" (click)="changeSensorsFilterTime(4)"
                        [ngClass]="{'selectedButton': this.sensorsFilterTime == 4}">{{this.localiser.get('indicators.month')}}</button>
                <button class="centerButton" (click)="changeSensorsFilterTime(5)"
                        [ngClass]="{'selectedButton': this.sensorsFilterTime == 5}">{{this.localiser.get('indicators.year')}}</button>
                <button class="rightButton" (click)="changeSensorsFilterTime(6)"
                        [ngClass]="{'selectedButton': this.sensorsFilterTime == 6}">{{this.localiser.get('indicators.custom')}}</button>
              </div>
              <div class="col-2 marginAuto">
                <div style="display: grid; margin: auto;">
                  <label class="textXS" style="margin: auto 0">{{this.localiser.get('indicators.maxInterval')}}</label>
                  <input type="number" max="1000" min="1" class="textS" [(ngModel)]="interval"
                         (ngModelChange)="changeIntervalInputWhenChange($event)">
                </div>
              </div>
              <div class="col-1 marginAuto" style="text-align: center">
                <span class="material-icons-outlined textXXM refreshButton"
                      [ngClass]="{disabledButton: this.checkDisabledCustom()}"
                      (click)="refreshData()">
                  refresh
                </span>
                <!--
                <button [disabled]="checkDisabledCustom()"
                        [ngClass]="{customButtonColorReverseDisabled: this.checkDisabledCustom()}"
                        class="customButtonColorReverse textS" mat-button (click)="this.changeSensorsFilterTime(6)">
                  Update
                </button>-->
              </div>
            </div>
            <div *ngIf="sensorsFilterTime == 6" class="row textS" style="height: 10%; margin: 2% auto auto; width: fit-content; text-align: center">
              <div class="col-6">
                <h6 class="textS+">{{this.localiser.get('indicators.start')}}</h6>
                <input type="datetime-local" [(ngModel)]="startCustomTime">
              </div>
              <div class="col-6">
                <h6 class="textS+">{{this.localiser.get('indicators.end')}}</h6>
                <input type="datetime-local" [(ngModel)]="endCustomTime">
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>


  </div>
</div>
